import { ButtonConnect } from '@features/events/common/button-connect';
import { ButtonBuy } from 'library/components/events';
import { checkEventEnd } from 'library/helpers/events/dateSets';
import { useMyTickets } from 'library/hooks/events';
import { ButtonEventEnd, ButtonTickets } from './frames';

interface Props {
  availablePlaces: number;
  timeEnd: string;
  timeStart: string;
  mode: string;
  href?: string | null;
}

export const VisitorActions: React.FC<Props> = ({
  availablePlaces,
  timeEnd,
  mode,
  href,
  timeStart,
}) => {
  const { tickets, onBuy, isAuth } = useMyTickets();
  const hasTickets = tickets.length > 0;
  const isEventStarted = new Date(timeStart) <= new Date(Date.now());

  if (checkEventEnd(timeEnd)) {
    return <ButtonEventEnd />;
  }

  if (!hasTickets) {
    return <ButtonBuy places={availablePlaces} totalTickets={tickets.length} handler={onBuy} />;
  }

  if (isAuth) {
    return mode === 'O' ? (
      <ButtonTickets />
    ) : href ? (
      <ButtonConnect href={href} isEventStarted={isEventStarted} />
    ) : null;
  }

  return null;
};
